import { z } from 'zod'

export const instrumentSearchQuerySchema = z.object({
  query: z.string().min(1).max(100),
})

export type InstrumentSearchQueryDto = z.infer<typeof instrumentSearchQuerySchema>

export const instrumentSearchResultSchema = z.object({
  uid: z.string(),
  figi: z.string(),
  ticker: z.string(),
  name: z.string(),
  instrumentType: z.string(),
  classCode: z.string(),
  isin: z.string(),
  apiTradeAvailableFlag: z.boolean(),
})

export type InstrumentSearchResultDto = z.infer<typeof instrumentSearchResultSchema>
